
import { Component, Vue, Watch } from "vue-property-decorator";
import config from "./config";
import YtoTable from "@/views/components/YtoTable/TtoTable.vue";
import Scan from "@/views/components/Scan/Scan.vue";
import deviceItem from "@/views/components/DeviceStatus/deviceItem";

@Component({
  name: "Form3",
  components: {
    YtoTable,
    Scan
  }
})
export default class extends Vue {
  @Watch("formmodel2", { deep: true })
  onChildChanged(val: string) {
    obj_ScanForWeighbridgeTare.sendFormDataToNet(val);
  }
  mounted() {
    try {
          obj_ScanForWeighbridgeTare.regist_errormsgcallback(this.errormsgcallback);
    obj_ScanForWeighbridgeTare.sendFormDataToNet(this.formmodel2);
    obj_ScanForWeighbridgeTare.regist_updateformdata(
      this.updateformdatacallback
    );

    obj_ScanForWeighbridgeTare.regist_datahistorycallback(
      this.datahistorycallback
    );
    } catch (error) {
            console.log("地磅称重2Vue出现异常:" + error);

    }

    // obj_ScanForWeighbridgeTare.regist_choosewhichcartype(
    //   this.choosewhichcartypecallback
    // );
    //初始化设备状态
    // this.deviceItems = [];
    // for (let index = 1; index <= 12; index++) {
    //   this.deviceItems.push({
    //     name: "设备" + index.toString(),
    //     title: index.toString(),
    //     status: "defult",
    //   });
    // }
    // var el = document.getElementById("input_scancode_id");
    // this.selectElementContents(el);
  }
  public selectElementContents(el) {
    //失去焦点，获取焦点
    el.blur();
    el.focus();
  }
  public updateformdatacallback(result) {
    if (
      this.formmodel2.input_LicensePlateNumber !=
      result.input_LicensePlateNumber
    ) {
      this.formmodel2.input_LicensePlateNumber =
        result.input_LicensePlateNumber;
    }
    if (this.formmodel2.input_OldTareWeight != result.input_OldTareWeight) {
      this.formmodel2.input_OldTareWeight = result.input_OldTareWeight;
    }
    if (this.formmodel2.input_WeightDate != result.input_WeightDate) {
      this.formmodel2.input_WeightDate = result.input_WeightDate;
    }
    if (this.formmodel2.input_CarSign != result.input_CarSign) {
      this.formmodel2.input_CarSign = result.input_CarSign;
    }
    if (this.formmodel2.input_CarType != result.input_CarType) {
      this.formmodel2.input_CarType = result.input_CarType;
    }
    if (this.formmodel2.input_TareWeight != result.input_TareWeight) {
      this.formmodel2.input_TareWeight = result.input_TareWeight;
    }
  }
  // public choosewhichcartypecallback(carNumber, carNumberExtend) {
  //   this.$confirm(
  //     "车牌号码为" +
  //       carNumber +
  //       "，挂车车牌为" +
  //       carNumberExtend +
  //       "。\r\n请选择",
  //     "提示",
  //     {
  //       confirmButtonText: "确定",
  //       cancelButtonText: "取消",
  //       type: "warning",
  //     }
  //   )
  //     .then(() => {
  //       this.$message({
  //         type: "success",
  //         message: "选择挂车",
  //       });
  //       obj_ScanForWeighbridgeTare.cPQuery(carNumberExtend);
  //     })
  //     .catch(() => {
  //       this.$message({
  //         type: "success",
  //         message: "选择车牌",
  //       });
  //       obj_ScanForWeighbridgeTare.cPQuery(carNumber);
  //     });
  // }
  public datahistorycallback(datalist) {
    this.showPrintedList = datalist;
  }
  //错误消息回调显示方法
  public errormsgcallback(data) {
    this.errormessage = data;
  }
  public PrintAndUploadFunc() {
    obj_ScanForWeighbridgeTare.printAndUpload(this.formmodel2);
  }
  public UploadFunc() {
    obj_ScanForWeighbridgeTare.upload(this.formmodel2);
  }
  public ReweighFunc() {
    this.formmodel2.input_ScanCode = this.ytoCode.toUpperCase();
    obj_ScanForWeighbridgeTare.reweigh(this.formmodel2);
  }
  public loading = false;
  public list = [];
  public option = [];
  public remoteMethod(query) {
    if (query !== "") {
      this.loading = true;
      var result = obj_ScanForWeighbridgeTare.queryCP(query);
      var resultObj = JSON.parse(result);
      this.list = resultObj.CPList.map(item => {
        return { value: `${item}`, label: `${item}` };
      });
      setTimeout(() => {
        this.loading = false;
        this.option = this.list.filter(item => {
          return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
        });
      }, 200);
    } else {
      this.option = [];
    }
  }
  private errormessage = "";
  private deviceItems: deviceItem[] = [];
  public ytoCode = "";

  //扫描区扫码
  private ytocodeget() {
    this.formmodel2.input_ScanCode = this.ytoCode.toUpperCase();
    obj_ScanForWeighbridgeTare.queryFacade(this.formmodel2);
  }
  // public QueryFacadeCallback(result) {
  //   if (
  //     this.formmodel2.input_LicensePlateNumber !=
  //     result.input_LicensePlateNumber
  //   ) {
  //     this.formmodel2.input_LicensePlateNumber =
  //       result.input_LicensePlateNumber;
  //   }
  //   if (this.formmodel2.input_OldTareWeight != result.input_OldTareWeight) {
  //     this.formmodel2.input_OldTareWeight = result.input_OldTareWeight;
  //   }
  //   if (this.formmodel2.input_WeightDate != result.input_WeightDate) {
  //     this.formmodel2.input_WeightDate = result.input_WeightDate;
  //   }
  //   if (this.formmodel2.input_CarSign != result.input_CarSign) {
  //     this.formmodel2.input_CarSign = result.input_CarSign;
  //   }
  //   if (this.formmodel2.input_CarType != result.input_CarType) {
  //     this.formmodel2.input_CarType = result.input_CarType;
  //   }
  //   if (this.formmodel2.input_TareWeight != result.input_TareWeight) {
  //     this.formmodel2.input_TareWeight = result.input_TareWeight;
  //   }
  // }
  public carlabel = "";
  private config = config;

  private formmodel2: inputDataModel_WeighbridgeTare = {
    input_ScanCode: "",
    input_LicensePlateNumber: "",
    input_OldTareWeight: "",
    input_WeightDate: "",
    input_CarSign: "",
    input_CarType: "",
    input_TareWeight: ""
  };
  public showPrintedList = [];

  public options = [
    {
      value: "",
      label: ""
    }
  ];
}
